/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'cportal';
const componentName = 'cportal-info-modal';
const prefix = `${moduleName}.${componentName}`;

export const appSignaturesSyncLabel = `${prefix}.appSignaturesSyncLabel`;
export const siteNameInputLabel = `${prefix}.siteNameInputLabel`;
export const siteInputPlaceholder = `${prefix}.siteInputPlaceholder`;
export const contactInputLabel = `${prefix}.contactInputLabel`;
export const contactInputPlaceholder = `${prefix}.contactInputPlaceholder`;
export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleAdd = `${prefix}.modalTitleAdd`;
export const signaturesLabel = `${prefix}.signaturesLabel`;
export const systemProxyLabel = `${prefix}.systemProxyLabel`;
export const threatIntelligenceHeader = `${prefix}.threatIntelligenceHeader`;
export const enableCrsDataLabel = `${prefix}.enableCrsDataLabel`;
export const enableAutoDownloadWafLabel = `${prefix}.enableAutoDownloadWafLabel`;
export const enableApplicationRulesDbLabel = `${prefix}.enableApplicationRulesDbLabel`;
export const ipReputationLabel = `${prefix}.ipReputationLabel`;
export const enableAutoSyncIpLabel = `${prefix}.enableAutoSyncIpLabel`;
export const proxyHeader = `${prefix}.proxyHeader`;
export const wafCrsLabel = `${prefix}.wafCrsLabel`;
export const enableWafCrsLabel = `${prefix}.enableWafCrsLabel`;
export const enableUserAgentDbManagementLabel = `${prefix}.enableUserAgentDbManagementLabel`;
export const botManagementLabel = `${prefix}.botManagementLabel`;
export const userAgentDbLabel = `${prefix}.userAgentDbLabel`;
export const smartOperationsHeader = `${prefix}.smartOperationsHeader`;
export const enableInventoryDashboardLabel = `${prefix}.enableInventoryDashboardLabel`;
export const inventoryStatsLabel = `${prefix}.inventoryStatsLabel`;
export const deprecationWarningLabel = `${prefix}.deprecationWarningLabel`;
export const clusterNameLabel = `${prefix}.clusterNameLabel`;
export const clusterNamePlaceholder = `${prefix}.clusterNamePlaceholder`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit Cloud Services Settings',
    [modalTitleAdd]: 'Add Cloud Services Settings',
    [signaturesLabel]: 'Signatures',
    [appSignaturesSyncLabel]: 'Application Rules',
    [siteNameInputLabel]: 'Site',
    [siteInputPlaceholder]: 'Select Site',
    [contactInputLabel]: 'Default Contact',
    [contactInputPlaceholder]: 'Contacts',
    [systemProxyLabel]: 'Use Cloud Services Split Proxy',
    [wafCrsLabel]: 'WAF CRS',
    [enableWafCrsLabel]: 'Enable WAF CRS',
    [threatIntelligenceHeader]: 'Threat Intelligence',
    [enableCrsDataLabel]: 'Receive notifications when new CRS data is available',
    [enableAutoDownloadWafLabel]: 'Enable auto download WAF Signatures',
    [enableApplicationRulesDbLabel]: 'Enable auto-sync Application Rules DB updates',
    [ipReputationLabel]: 'IP Reputation',
    [enableAutoSyncIpLabel]: 'Enable auto-sync IP Reputation DB updates',
    [proxyHeader]: 'Proxy',
    [enableUserAgentDbManagementLabel]: 'Enable User Agent DB Sync',
    [botManagementLabel]: 'Bot Management',
    [userAgentDbLabel]: 'User Agent DB',
    [smartOperationsHeader]: 'Smart Operations',
    [enableInventoryDashboardLabel]: 'Enable Inventory Dashboard',
    [inventoryStatsLabel]: 'Inventory',
    [deprecationWarningLabel]: 'Following the discontinuation of the Trustwave commercial rule-set, the application rules feature will be deprecated on 2024-06-30. Any rules published before the date can be used.',
    [clusterNameLabel]: 'Cluster Name',
    [clusterNamePlaceholder]: 'Enter Cluster Name',
};
